const replaceNbspFromText = (text = '') => text.replace(/\u00a0/g, ' ')

export default replaceNbspFromText
